import { render, staticRenderFns } from "./PageHotels.vue?vue&type=template&id=4d2eb2ca&"
import script from "./PageHotels.vue?vue&type=script&lang=js&"
export * from "./PageHotels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2eb2ca')) {
      api.createRecord('4d2eb2ca', component.options)
    } else {
      api.reload('4d2eb2ca', component.options)
    }
    module.hot.accept("./PageHotels.vue?vue&type=template&id=4d2eb2ca&", function () {
      api.rerender('4d2eb2ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hotels/PageHotels.vue"
export default component.exports